export const isBooleanInPhP = (a) => {
  if (typeof a === 'string') {
    if (a === '' || a === '0') {
      return false;
    }
    return true;
  }
  return Boolean(a);
};
